module.exports = __webpack_public_path__ + "img/0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153.be5a96a2.png";